import { FC } from 'react';
import { Box, Typography } from '@mui/material';

export const ConversationItemsPlaceholder: FC = () => (
  <>
    <Box minHeight={(theme) => theme.spacing(1)} />
    <Typography align="center" variant="body2" color="textSecondary">
      There aren't any chats to see here right now.
    </Typography>
  </>
);
